import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { Box, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { IDefaultCaptionProps } from "./IDefaultViewProps";



// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultCaptionProps;
export const Caption = (props: AllProps) => {
    const classes = useStyles(useTheme());
    return (
        <Box className={classes.root}>
            <Typography variant="body1" color={"primary"}>
                {props.caption}
            </Typography>
            <Box className={classes.content}>
                {props.icon && <span className={classes.icon}>{props.icon}</span>}
                {props.loading ? (
                    <Skeleton className={classes.skeleton} animation="wave" />
                ) : (
                    props.children
                )}
            </Box>
        </Box>
    );
};

// CSS
const useStyles = makeStyles((theme: Theme) => ({
    root: {
        marginBottom: theme.spacing(1.5),
        width: "100%",
    },
    content: {
        display: "flex",
        alignItems: "center", // Align icon and content vertically
        marginLeft: theme.spacing(2),
    },
    icon: {
        marginRight: theme.spacing(1), // Add spacing between the icon and content
    },
    skeleton: {
        width: "100%",
        marginRight: theme.spacing(1)
    },
}));